import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Button,
  Chip,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material'
import { ExpandMoreIcon } from 'components/Icons'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate, useParams } from 'react-router-dom'
import EnrollmentsListItem from './ListItem'
import InActiveListItem from './InactiveListItem'
import { hasFullPermission } from 'store'

export default function EnrollmentsList({ campuses, activeCampuses, inactiveCampuses, districtTypes }) {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const { personId } = useParams()
  const [activeOpen, setActiveOpen] = useState(true)
  const [inactiveOpen, setInactiveOpen] = useState(false)

  if (!campuses) return null

  const hasActive = activeCampuses?.length >= 1
  const hasInactive = inactiveCampuses?.length >= 1

  return (
    <Box>
      <Box sx={{ m: 3 }}>

        {hasActive && (
          <Accordion
            expanded={activeOpen}
            onChange={(_, isExpanded) => setActiveOpen(isExpanded)}
            sx={{ boxShadow: 'none', border: '1px solid', borderColor: 'divider', borderRadius: '8px !important', '&:before': { display: 'none' }, mb: 3 }}
          >
            <AccordionSummary expandIcon={<ExpandMoreIcon />} sx={{ px: 2 }}>
              <Stack direction="row" alignItems="center" justifyContent="space-between" sx={{ width: '100%', pr: 1 }}>
                <Stack direction="row" alignItems="center" gap={1}>
                  <Typography variant="subtitle1" fontWeight="bold">
                    {t('Active Campuses')}
                  </Typography>
                  <Chip label={activeCampuses.length} size="small" color="primary" />
                </Stack>
                {hasFullPermission('people.campus') && (
                  <Button
                    size="small"
                    variant="contained"
                    color="primary"
                    onClick={e => { e.stopPropagation(); navigate(`/people/staff/${personId}/campus/new`) }}
                  >
                    {t('Add Campus')}
                  </Button>
                )}
              </Stack>
            </AccordionSummary>
            <AccordionDetails sx={{ p: 0 }}>
              <Table size="small">
                <TableHead>
                  <TableRow>
                    <TableCell>{t('Campus')}</TableCell>
                    <TableCell>{t('District Type')}</TableCell>
                    <TableCell>{t('Start Date')}</TableCell>
                    <TableCell>{t('Roles')}</TableCell>
                    {hasFullPermission('people.campus') && <TableCell align="right">{t('Action')}</TableCell>}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {activeCampuses.map((item, index) => (
                    <EnrollmentsListItem key={index} item={item} campuses={campuses} districtTypes={districtTypes} />
                  ))}
                </TableBody>
              </Table>
            </AccordionDetails>
          </Accordion>
        )}

        {hasInactive && (
          <>
            <Accordion
              expanded={inactiveOpen}
              onChange={(_, isExpanded) => setInactiveOpen(isExpanded)}
              sx={{ boxShadow: 'none', border: '1px solid', borderColor: 'divider', borderRadius: '8px !important', '&:before': { display: 'none' } }}
            >
              <AccordionSummary expandIcon={<ExpandMoreIcon />} sx={{ px: 2 }}>
                <Stack direction="row" alignItems="center" gap={1}>
                  <Typography variant="subtitle1" fontWeight="bold">
                    {t('Inactive Campuses')}
                  </Typography>
                  <Chip label={inactiveCampuses.length} size="small" color="default" />
                </Stack>
              </AccordionSummary>
              <AccordionDetails sx={{ p: 0 }}>
                <Table size="small">
                  <TableHead>
                    <TableRow>
                      <TableCell>{t('Campus')}</TableCell>
                      <TableCell>{t('District Type')}</TableCell>
                      <TableCell>{t('Start Date')}</TableCell>
                      <TableCell>{t('Deactivated Date')}</TableCell>
                      {hasFullPermission('people.campus') && <TableCell align="right">{t('Action')}</TableCell>}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {inactiveCampuses.map((item, index) => (
                      <InActiveListItem key={index} item={item} districtTypes={districtTypes} />
                    ))}
                  </TableBody>
                </Table>
              </AccordionDetails>
            </Accordion>
          </>
        )}
      </Box>
    </Box>
  )
}
